import {ArrowPositionType} from '../types';

const padding = 14;
export const getArrowspacingWidth = (
  arrowPosition: ArrowPositionType,
  tooltipWidth: number,
) => {
  switch (arrowPosition) {
    case 'TopRight':
      return tooltipWidth;
    case 'TopCenter':
      return tooltipWidth / 2 + padding;
    case 'TopLeft':
      return padding;
    case 'BottomRight':
      return tooltipWidth;
    case 'BottomCenter':
      return tooltipWidth / 2 + padding;
    case 'BottomLeft':
      return padding;
    default:
      return undefined;
  }
};
